import {
  AppBar,
  CssBaseline,
  IconButton,
  Toolbar,
  Typography,
  Chip,
  Tooltip
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import UserMenu from "./UserMenu";
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/features/store/store";
import DriverIDSelection from "../../../../pages/driverIdSelection/DriverIDSelection";
import { useState } from "react";
import RtsScanStore from "../../../../pages/rtsScanModule/RtsScanStore";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

type HeaderProps = {
  handleDrawerOpen: () => void;
};

const Header = ({ handleDrawerOpen }: HeaderProps) => {
  const navigate = useNavigate();
  const { globallySelectedDriverClientEmail } = useSelector(
    (state: RootState) => state.fdp
  );
  const [showDriverSelection, setShowDriverSelection] = useState(false);

  const { location } = RtsScanStore();
  const handleEdit = () => {
    const currentPath = window.location.pathname.toLowerCase();
    if (currentPath !== "/addrts") {
      toast.error("Cannot edit; go to RTS/RC page to edit. ");
      return;
    }
    if (location.isFenced) {
      setShowDriverSelection(true);
    } else {
      toast.error("Cannot edit; you are not in the geofence area.");
    }
  };

  return (
    <>
      <CssBaseline />
      <AppBar position="static" sx={{ backgroundColor: "primary.main" }}>
        <Toolbar sx={{ pr: "24px", minHeight: { sm: 45 } }}>
          <IconButton
            edge="start"
            sx={{ color: "white" }}
            aria-label="open drawer"
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h4"
            sx={{ flexGrow: 1, color: "white", textAlign: "center" }}
          >
            Command Ops
          </Typography>
          {/* <ThemeSettingsMenu /> */}
          {globallySelectedDriverClientEmail?.driverEmail && (
            <Chip
              sx={{
                color: "white",
                borderColor: "white",
                bgcolor: "#0d540d",
                fontSize: "12px",
                textAlign: "end",
              }}
              label={globallySelectedDriverClientEmail.driverEmail}
              variant="outlined"
              onClick={handleEdit}
              clickable
            />
          )}

          <Tooltip title="Knowledge Hub">
            <IconButton
              sx={{ color: "white" }}
              onClick={() => navigate("/knowledge-hub")}
            >
              <TipsAndUpdatesOutlinedIcon />
            </IconButton>
          </Tooltip>

          <UserMenu />
        </Toolbar>
      </AppBar>
      {showDriverSelection && (
        <DriverIDSelection
          reselection={true}
          setShowDriverSelection={setShowDriverSelection}
        />
      )}
    </>
  );
};

export default Header;
